export const isValidSectorIndustry = (
  arrayToCheck, value: string,
) => arrayToCheck[value];
